import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import Saree from "../images/Saree.jpg";
import Churidar from "../images/churidar.jpg";
import Jeans from "../images/Jeans.jpg";
import Lehenga from "../images/Lehenga.jpg";
import Tshirt from "../images/Crop t-shirt.jpg";
import Top from "../images/top.jpg";
import Kurti from "../images/kurti_womens.jpg";


function WomensWear() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <br />

      <div className='nadiacloth'>
        <div className="album py-1">
          <div className="container mt-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Womens Wear</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='saree'>
                    <div className="card">
                      <img src={Saree} className="card-img-top" alt="Saree" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Saree</h5>
                        <p className="card-text">Best Saree available</p>
                        <a href="saree" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-md-6 mt-3">
                  <a href='Churidar'>
                    <div className="card" >
                      <img src={Churidar} className="card-img-top" alt="menswear" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Churidar</h5>
                        <p className="card-text">Best High demand products</p>
                        <a href="Churidar" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6  me-2 mt-3">
                  <a href='jeans'>
                    <div className="card" >
                      <img src={Jeans} className="card-img-top" alt="Siddheswari Bastralaya_Jeans" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Jeans </h5>
                        <p className="card-text">Best High demand products</p>
                        <a href="jeans" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>

                <div className="col-md-6 mt-3">
                  <a href='Lehenga'>
                    <div className="card" >

                      <img src={Lehenga} className="card-img-top" alt="Lehenga" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Lehenga</h5>
                        <p className="card-text">Best High demand products</p>
                        <a href="Lehenga" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

            </div>




          </div>
        </div>
      </div>

      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6 me-2 mt-3">
                  <a href='t-shirt'>
                    <div className="card">
                      <img src={Tshirt} className="card-img-top" alt="Tshirt" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">T-Shirt</h5>
                        <p className="card-text">Best T-Shirt available</p>
                        <a href="t-shirt" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-md-6 mt-3">
                  <a href='top'>
                    <div className="card" >

                      <img src={Top} className="card-img-top" alt="Fancy crop top" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Fancy crop top</h5>
                        <p className="card-text">Best High demand products</p>
                        <a href="top" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-start align-items-center mb-2">
                <div className="col-md-6  me-2 mt-3">
                  <a href='kurti'>
                    <div className="card" >
                      <img src={Kurti} className="card-img-top" alt="Kurti" />
                      <div className="card-body">
                        <h5 className="card-title mb-1">Kurti </h5>
                        <p className="card-text">Best High demand products</p>
                        <a href="kurti" className="learn">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg></a>
                      </div>
                    </div>
                  </a>
                </div>

              
              </div>

            </div>





          </div>
        </div>
      </div>
      <br />
    </div>
  )
}

export default WomensWear